export default "__VITE_PUBLIC_ASSET__57ee89c5__"